import { useMemo } from 'react';
import { useCurrentArtistId } from './useCurrentArtistId';
import { useArtist } from './useArtist';
import { formatArtist } from './formatArtist';

export function useCurrentArtist() {
  const artistId = useCurrentArtistId();

  const fallback = useMemo(
    () =>
      formatArtist({
        uri: `spotify:artist:${artistId}`,
        imageUrl: '',
        name: artistId,
      }),
    [artistId],
  );

  return useArtist(artistId) || fallback;
}
